<script lang="ts">
	import type { PageData } from "./$types";
	import { page } from '$app/stores';
	import BlogMain from '$lib/components/BlogMain.svelte';
	import RelatedBlogs from '$lib/components/RelatedBlogs.svelte';
	import MetaTags from "$lib/components/MetaTags.svelte";
	import JsonLD from "$lib/components/JsonLD.svelte";
	import AnimatedRoute from "$lib/components/AnimatedRoute.svelte";
	import { currentBootcamp } from "$lib/client/stores/nucamp-currentbootcamp";
	export let data: PageData;

	let jsonldPerson: any;
	$: if (data?.blog?.paywallasset?.bootcampId && data?.bootcamps) {
		const bootcamp = data.bootcamps.find((b) => b.id === data.blog?.paywallasset?.bootcampId);
		if (bootcamp) {
			currentBootcamp.set(bootcamp);
		}
	}

	if (data.blog.authorDetails) {
		jsonldPerson = {
				"@context": "http://schema.org",
				"@type": "Person",
				"name": `${data.blog.authorDetails.firstname} ${data.blog.authorDetails.lastname}`,
				"url": `${$page.url.origin}/blogs/authors/${data.blog.authorDetails.authorUrl}`,
				"image": data.blog.authorDetails.img,
				"jobTitle": data.blog.authorDetails.title,
				"affiliation": "Nucamp Vibe Coding Bootcamp",
				"email": data.blog.authorDetails.email,
				"sameAs": [] as string[],
				"worksFor": {
						"@type": "Organization",
						"name": "Nucamp Vibe Coding Bootcamp",
						"url": "https://www.nucamp.co"
				}
		}
		if (data.blog.authorDetails?.linkedin) jsonldPerson.sameAs.push(data.blog.authorDetails.linkedin);
		if (data.blog.authorDetails?.twitter) jsonldPerson.sameAs.push(data.blog.authorDetails.twitter);
  }

</script>

<MetaTags metatags={data.metatags}/>
{#if data?.blog?.faq}
    <JsonLD jsonLD={data.blog.faq}/>
{/if}
{#if jsonldPerson}
    <JsonLD jsonLD={jsonldPerson}/>
{/if}
{#if data?.blogJsonLD}
    <JsonLD jsonLD={data.blogJsonLD}/>
{/if}
<AnimatedRoute key={data?.blog?.id}>
	<main class="flex flex-wrap lg:pt-6 stripe-inside">
			<div class="w-full md:w-8/12 pr-0 md:pr-4">
				<BlogMain blog={data.blog} supForm={data.form} bootcamps={data.bootcamps}>
				</BlogMain>
			</div>
			<div class="w-full md:w-4/12 px-3 md:pt-0 md:p-6 md:pr-0">
				<RelatedBlogs related={data.relatedBlogs}>
						<h3 slot="header" class="pb-4">Related Blogs</h3>
				</RelatedBlogs>
			</div>
	</main>
</AnimatedRoute>